import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroExclamationTriangle } from '@ng-icons/heroicons/outline';
import { AppService } from '../../../services/app.service';
import { ThemeService } from '../../../services/theme.service';
import { environment } from '../../../../environments/environment';
import { AdminService } from '../../../services/admin.service';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [NgIcon, MatButtonModule],
  providers: [provideIcons({ heroExclamationTriangle })],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent implements OnInit {
  errMsg: any;
  errTitle: any;
  errStatus: any;
  storeLogo: '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private adminService: AdminService,
    private themeService: ThemeService
  ) {
    this.storeLogo =
      appService.getDecodedAccessToken()?.shopping_logo_url ??
      '../../../assets/img/gitly-logo.png';
    route.queryParams.subscribe((params) => {
      this.errMsg = params['msg'] || '';
      this.errStatus = params['status'] || '';
      this.errTitle =
        params['status'] == 409
          ? 'Cupom já validado anteriormente!'
          : params['status'] == 401
          ? 'Sessão expirada!'
          : 'Ops, houve um erro!';
    });
  }

  ngOnInit() {
    // Aplica o tema
    this.themeService.applyThemeIfAvailable();
  }

  enableScan() {
    this.router.navigate(['/qrScan']);
  }
  backToAdmin() {
    window.location.href = environment.appAdminUrl + "/" + this.adminService.getShoppingCode();
  }
}
